





















import { Vue, Component, Prop } from 'vue-property-decorator';

import Avatar from '~/components/cards/Avatar.vue';

@Component({
  components: { Avatar },
})
export default class RouteTimesItem extends Vue {
  @Prop(Object) time: {};
}
